import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=6c2d3db1&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=6c2d3db1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2d3db1",
  null
  
)

export default component.exports
import {QBreadcrumbs,QBreadcrumbsEl,QBtn,QCheckbox,QInput,QTable,QTr,QTh,QDialog,QCard,QCardSection,QCardActions,QSelect,QItem,QItemSection,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QBreadcrumbsEl,QBtn,QCheckbox,QInput,QTable,QTr,QTh,QDialog,QCard,QCardSection,QCardActions,QSelect,QItem,QItemSection})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
